import {STATUS_TO_DISPLAY} from "../Orders/OrdersGrid/OrderStatus/OrderStatusSwitcher/OrderStatusSwitcher";

const newOrderMessage = (data) => {
    return `התווספה הזמנה חדשה ל${data.order.address}`;
};

const deleteOrderMessage = (data) => {
    if (data.order.status === "DELIVERED")
        return undefined;

    return `ההזמנה ל${data.order.address} נמחקה`;
};

const updateOrderMessage = (data) => {
    const statusChange = data.changes.find(change => change.path.join('.') === 'status');

    if (statusChange && statusChange.val !== 'ASSIGNED') {
        const displayStatus = STATUS_TO_DISPLAY[statusChange.val];

        return `ההזמנה ל${data.order.address} עברה לסטטוס ${displayStatus}`
    }

    if (!statusChange || data.changes.length > 1)
        return `ההזמנה ל${data.order.address} עודכנה`;
};

const newUserMessage = (data) => {
    return `התווסף משתמש חדש בשם ${data.user.name}`;
};

const deleteUserMessage = (data) => {
    return `המשתמש ${data.user.name} נמחק`;
};

const updateUserMessage = (data) => {
    const currentlyAvailableChange = data.changes.find(change => change.path.join('.') === 'profiles.messenger.isCurrentlyAvailable');
    const isWhileMissionChange = data.changes.find(change => change.path.join('.') === 'profiles.messenger.isWhileMission');

    if (isWhileMissionChange && isWhileMissionChange.val)
        return undefined;

    if (currentlyAvailableChange) {
        if (currentlyAvailableChange.val)
            return `השליח ${data.user.name} זמין`;
        else
            return `השליח ${data.user.name} יצא מזמינות`;
    } else {
        return `המשתמש ${data.user.name} עודכן`;
    }
};

const newAssignedGroupMessage = (messageData, allData) => {
    const groupMessenger = allData.messengers.find(messenger => messenger.id === messageData.group.messenger_id);

    if (messageData.group.route.length === 1)
        return `השליח ${groupMessenger.name} שובץ למשימת שילוח עם הזמנה אחת`;
    else
        return `השליח ${groupMessenger.name} שובץ למשימת שילוח עם ${messageData.group.route.length} הזמנות`;
};

const deleteAssignedGroupMessage = (messageData, allData) => {
    const groupMessenger = allData.messengers.find(messenger => messenger.id === messageData.group.messenger_id);

    return `משימת השילוח של השליח ${groupMessenger.name} בוטלה`;
};

const updateAssignedGroupMessage = (messageData, allData) => {
    const finishStatusChange = messageData.changes.find(change => change.path.join('.') === 'status' && change.val === "FINISHED");
    const groupMessenger = allData.messengers.find(messenger => messenger.id === messageData.group.messenger_id);

    if (finishStatusChange)
        return `משימת השילוח של השליח ${groupMessenger.name} הסתיימה`;
    else
        return `משימת השילוח של השליח ${groupMessenger.name} עודכנה`;
};

const messageFunctions = {
    "NewOrder": newOrderMessage,
    "DeleteOrder": deleteOrderMessage,
    "UpdateOrder": updateOrderMessage,
    "NewUser": newUserMessage,
    "DeleteUser": deleteUserMessage,
    "UpdateUser": updateUserMessage,
    "NewAssignedGroup": newAssignedGroupMessage,
    "DeleteAssignedGroup": deleteAssignedGroupMessage,
    "UpdateAssignedGroup": updateAssignedGroupMessage,
};

export const getMessage = (message, allData) => {
    if (message.topic in messageFunctions)
        return messageFunctions[message.topic](message.data, allData);

    return undefined;
};